const state = {
  bookingList: [],
  companyList: [],
  companyInfo: JSON.parse(localStorage.getItem('corporateIdentityInfo')),
  selectedCompany: null
}
export default state
